import { ApiProperty } from '@nestjs/swagger';
import { Type } from 'class-transformer';
import { IsEnum, IsNumber, IsOptional, Max, Min } from 'class-validator';
import { PagedRequest, PagedResponse } from '../../request';
import { DEFAULT_PER_PAGE_MAX } from '../../../const/pagination';
import type { FilterableValue } from '../../filterable';
import { DateISOString } from '../../../types';
import { SortableRequest, Sorters } from '../../sortable';
import { PromocodeUsagaeViewModel } from './usage.view';
import { PromocodeType } from './type';
import { PromocodeUsageStatus } from './usageStatus';

type SortableFields = keyof Pick<PromocodesUsageQuery, 'type' | 'createdAt' | 'status' | 'activatedAt' | 'acceptorType' | 'acceptorCareer'>;

export type FilterableFields = keyof Pick<
  PromocodesUsageQuery,
  'type' | 'status' | 'createdAt' | 'activatedAt' | 'acceptorType' | 'acceptorCareer'
>;

export class PromocodesUsageQuery implements PagedRequest, SortableRequest {
  @ApiProperty()
  @IsOptional()
  promocode?: string;

  @ApiProperty()
  @IsOptional()
  @Type(() => Number)
  @IsEnum(PromocodeType)
  type?: FilterableValue<PromocodeType>;

  @ApiProperty()
  @IsOptional()
  @Type(() => Number)
  status?: FilterableValue<PromocodeUsageStatus>;

  @ApiProperty()
  @IsOptional()
  createdAt?: FilterableValue<DateISOString>;

  @ApiProperty()
  @IsOptional()
  activatedAt?: FilterableValue<DateISOString>;

  @ApiProperty()
  @IsOptional()
  ownerId?: FilterableValue<number>;

  @ApiProperty()
  @IsOptional()
  acceptorId?: FilterableValue<number>;

  @ApiProperty()
  @IsOptional()
  acceptorType?: FilterableValue<number>;

  @ApiProperty()
  @IsOptional()
  acceptorCareer?: FilterableValue<number>;

  @ApiProperty({ required: false })
  @Type(() => Number)
  @IsOptional()
  @IsNumber()
  @Min(1)
  page?: number;

  @ApiProperty({ required: false })
  @Type(() => Number)
  @IsOptional()
  @IsNumber()
  @Min(1)
  @Max(DEFAULT_PER_PAGE_MAX)
  pagination?: number;

  sorters?: Sorters<SortableFields>;
}

export class PromocodesUsageResponse implements PagedResponse<PromocodeUsagaeViewModel> {
  items: PromocodeUsagaeViewModel[];
  totalCount: number;
}
